import React from 'react'
import { ManageState } from './manageState';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import TableCustom from '../../../../components/table/tableCustom';
import StateComponents from '../../../../components/state-component/StateComponents';
import ModalCustom from '../../../../components/modal/ModalCustom';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { useNavigate } from 'react-router-dom';

type Props = {}

const CollectionsImage: React.FC<Props> = ({ }: Props) => {
    const navigate = useNavigate();
    const {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        // formState,
        // showModal,
        setShowModal,
        // handleSubmit,
        // handleCloseModal,
        // setFormState,
        setKeyword,
        handleChangeDateRange,
        date_range,
        gallery_type_data,
        set_id_gallery_type,
        id_gallery_type,
        checkPermit
    } = ManageState();
    return (
        <ContainerLayout
            title='ภาพถ่าย'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "แกลเลอรี",
                            name: "แกลเลอรี",
                            disabled_match: true,
                            pathName: ""
                        },
                        {
                            key: "ภาพถ่าย",
                            name: "ภาพถ่าย",
                            pathName: routeName.cms_website.collection_image
                        },
                    ]}
                />
            }
            content={

                <div className='w-full'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 4
                                },
                                fieldProps: {
                                    placeholder: "ค้นหา ชื่อ",
                                    onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                }
                            },
                            {
                                seq: 2,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.gallery_type_name || "",
                                    labelId: "id_gallery_type",
                                    placeholder: "หมวดหมู่",
                                    onChange: (_, val) => set_id_gallery_type(val),
                                    options: gallery_type_data,
                                    value: id_gallery_type
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    value: {
                                        end_date: date_range.end_date,
                                        start_date: date_range.start_date
                                    },
                                    placeholder: "ช่วงวันที่"
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 6,
                                    md: 2
                                },
                                hidden: !checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            key: "ADD2",
                                            label: "เพิ่มภาพถ่าย",
                                            buttonProps: {
                                                onClick: () => {
                                                    navigate(routeName.cms_website.collection_image_create)
                                                },
                                            },
                                            type: "ADD2"
                                        }
                                    ]
                                }
                            }
                        ]}
                    />
                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                    {/* {showModal !== "" && (
                        <ModalCustom
                            open
                            title={showModal === 'VIEW' ? 'รายละเอียดแท็ก' : 'เพิ่มแท็ก'}
                            subTitle='กรุณาระบุรายละเอียด'
                            onClose={handleCloseModal}
                            containerButton={{
                                onClose: () => handleCloseModal(),
                                onSubmit: () => handleSubmit(),
                                disabled_submit: !formState.tag_name,
                                hidden_submit: showModal === 'VIEW'
                            }}
                            component={
                                <div className='w-full'>
                                    <StateComponents
                                        disabledAllField={showModal === 'VIEW'}
                                        sxContainer={{ my: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, tag_name: e.target.value })),
                                                    value: formState.tag_name,
                                                    required: true,
                                                    placeholder: "ระบุ",
                                                    heading: "ชื่อแท็ก"
                                                }
                                            }
                                        ]}
                                    />
                                </div>
                            }
                        />
                    )} */}
                </div>
            }
        />
    )
}

export default CollectionsImage